<template>

  <div>

    <settings-header />
    <preferences :tasks-setting="tasksSetting" />

  </div>

</template>

<script>

  import SettingsHeader from './components/header';
  import Preferences from './components/preferences';

  export default {
    name: 'SalesforceSettings',
    props: {
      tasksSetting: {required: true}
    },
    components: {
      SettingsHeader,
      Preferences
    }
  }

</script>
